import {api} from '@/http'

// 投后列表
const getTH = (data, callback, back) => {
  api('/api/TH_WP/List', 'post', data, callback, back)
}

// 投后添加
const addTH = (data, callback, back) => {
  api('/api/TH_WP/Insert', 'post', data, callback, back)
}

// 投后删除
const delTH = (id, callback, back) => {
  api('/api/TH_WP/Delete', 'post', {Id: id}, callback, back)
}

// 投后详情
const detailTH = (id, callback, back) => {
  api('/api/TH_WP/Detail', 'post', {Id: id}, callback, back)
}

// 投后收费列表
const getTHCharge = (data, callback, back) => {
  api('/api/TH_WP/ChargeList', 'post', data, callback, back)
}
export default {
  getTH,
  addTH,
  delTH,
  detailTH,
  getTHCharge
}



// WEBPACK FOOTER //
// ./src/api/th/index.js